<template>
  <div class="tw-bg-blue-highlight tw-flex tw-items-center tw-rounded-lg tw-p-2 tw-gap-2">
    <slot />
  </div>
</template>
